import { Formik, Form } from 'formik';

import { Button } from './Button';
import { InputGroup } from './Inputs';
import { useAccountUser } from '../contexts/User';

enum FieldName {
  code = 'code',
  email = 'email',
}

enum SubmitType {
  resend = 'resend',
  verify = 'verify',
}

interface FormState {
  code: string;
  submitType: string;
}

interface EmailVerifyFormProps {
  handleVerifyEmail: (code: string) => Promise<void>;
  handleResendCode: () => Promise<void>;
}

export default function EmailVerifyForm({
  handleVerifyEmail,
  handleResendCode,
}: EmailVerifyFormProps) {
  const { user } = useAccountUser();
  if (!user) return null;

  const onSubmit = async (values: FormState, { setSubmitting, setFieldValue }: any) => {
    if (values.submitType === SubmitType.resend) {
      await handleResendCode();
      setFieldValue(FieldName.code, '');
    } else {
      await handleVerifyEmail(values.code);
    }

    setSubmitting(false);
  };

  return (
    <Formik initialValues={{ code: '', submitType: '' }} onSubmit={onSubmit}>
      {({ setFieldValue, isSubmitting }) => (
        <Form>
          <h2 className="mb-6 text-xl font-bold">Email Verification</h2>
          <InputGroup name={FieldName.email} label="Email" disabled placeholder={user.email} />
          <InputGroup
            name={FieldName.code}
            label="Verification Code"
            placeholder="Check your email for verification code"
          />
          <div className="flex flex-row-reverse justify-between mt-6 ">
            <Button
              outline
              type="submit"
              onClick={() => setFieldValue('submitType', SubmitType.verify)}
              disabled={isSubmitting}
              loading={isSubmitting}
            >
              Verify Email
            </Button>
            <Button
              type="submit"
              onClick={() => setFieldValue('submitType', SubmitType.resend)}
              disabled={isSubmitting}
            >
              Resend Code
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
